import dynamic from 'next/dynamic'
import { ZoningIcon } from 'src/components/insights/icons/zoning'
import { InsightBuilderWidget } from 'src/types/insight-builder'
import asOfRightsPreview from 'src/assets/images/widgets-previews/as-of-rights.png'
import conditionalUsersPreview from 'src/assets/images/widgets-previews/conditional-uses.png'
import prohibitedUseCasesPreview from 'src/assets/images/widgets-previews/prohibited-use-cases.png'

const ZoningAsOfRights = dynamic(() => import('src/components/insights/zoning/uses/zoning-as-of-rights'), {
  ssr: false,
})
const ZoningConditionalUses = dynamic(() => import('src/components/insights/zoning/uses/zoning-conditional-uses'), {
  ssr: false,
})
const ZoningProhibitedUseCases = dynamic(
  () => import('src/components/insights/zoning/uses/zoning-prohibited-uses-cases'),
  {
    ssr: false,
  }
)

export const ZoningAsOfRightsWidget: InsightBuilderWidget = {
  id: 'zoning-as-of-rights',
  name: 'As Of Rights',
  type: 'Zoning',
  icon: ZoningIcon,
  component: ZoningAsOfRights,
  supportedResultTypes: ['alphamap-location'],
  preview: asOfRightsPreview,
  minTier: 'intermediate',
}

export const ZoningConditionalUsesWidget: InsightBuilderWidget = {
  id: 'zoning-conditional-uses',
  name: 'Conditional Uses',
  type: 'Zoning',
  icon: ZoningIcon,
  component: ZoningConditionalUses,
  supportedResultTypes: ['alphamap-location'],
  preview: conditionalUsersPreview,
  minTier: 'intermediate',
}

export const ZoningProhibitedUseCasesWidget: InsightBuilderWidget = {
  id: 'zoning-prohibited-use-cases',
  name: 'Prohibited Use Cases',
  type: 'Zoning',
  icon: ZoningIcon,
  component: ZoningProhibitedUseCases,
  supportedResultTypes: ['alphamap-location'],
  preview: prohibitedUseCasesPreview,
  minTier: 'intermediate',
}
